import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Success_Icon } from "@/lib/Images";
import { AlertTriangle } from "lucide-react";

/**
 * Reusable success modal for tenant, campaign,
 * experience, user creation and other workflows.
 */
const SuccessModal = ({
  open,
  onClose,

  title,
  description,

  primaryButtonText,
  secondaryButtonText,

  iconType = "success", // iconType="success" or warning
  showIcon = true,
  onPrimaryClick,
  onSecondaryClick,

  hidePrimaryButton = false,
  hideSecondaryButton = false,

  titleClassName = "",
  children,
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="w-[calc(100vw-32px)] max-w-2xl max-h-[90vh]
        overflow-y-auto rounded-lg border border-brand-11
        bg-brand-10 px-5 py-8 text-center text-neutral-100
        shadow-2xl sm:px-8 sm:py-10 lg:px-10 lg:py-14"
      >
        {children && <div className="w-full">{children}</div>}
        <DialogHeader className="text-center">
          {showIcon &&
          (iconType === "warning" ? (
            <div className="mx-auto mb-4 flex items-center justify-center">
              <AlertTriangle
                className="h-12 w-12 fill-[#D44950] text-brand-10"
                strokeWidth={2}
              />
            </div>
          ) : (
            <div className="mx-auto mb-4 h-20 w-20 rounded-full  flex items-center justify-center">
              <img
                src={Success_Icon} // your image path here
                alt="Success"
                className="h-18 w-18"
              />
            </div>
          ))}

          <DialogTitle
            className={`text-center text-xl font-bold sm:text-2xl ${
              titleClassName || "text-neutral-100"
            }`}
            //  className="text-center text-xl font-bold text-neutral-100 sm:text-2xl"
          >
            {title}
          </DialogTitle>

          <DialogDescription className="mx-auto !mt-4 max-w-xl text-center text-sm leading-relaxed text-neutral-100/80 sm:text-base">
            {description}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-8 flex w-full flex-col gap-3 md:flex-row md:justify-center">
          {!hideSecondaryButton && (
            <Button
              type="button"
              variant="outline"
              onClick={onSecondaryClick || onClose}
              className="h-11 w-full border-[#607A9B] bg-[#223957] px-7 text-sm font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100 md:w-auto"
            >
              {secondaryButtonText}
            </Button>
          )}
          {!hidePrimaryButton && (
            <Button
              type="button"
              onClick={onPrimaryClick}
              className="h-11 w-full bg-gradient-to-r from-brand-12 to-brand-13 px-5 text-sm font-bold text-neutral-100 hover:opacity-90 md:w-auto"
            >
              {primaryButtonText}
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;

// import { Check } from "lucide-react";
// import { Button } from "@/components/ui/button";

// import {
//   Dialog,
//   DialogContent,
//   DialogDescription,
//   DialogFooter,
//   DialogHeader,
//   DialogTitle,
// } from "@/components/ui/dialog";

// const SuccessModal = ({ open, onClose, onAddExperience, onAddCampaign }) => {
//   return (
//     <Dialog open={open} onOpenChange={onClose}>
//       <DialogContent
//         className="w-[calc(100vw-32px)] max-w-2xl max-h-[90vh] overflow-y-auto rounded-lg border border-brand-11 bg-brand-10 px-5 py-8 text-center
//           text-neutral-100 shadow-2xl sm:px-8 sm:py-10 lg:px-10 lg:py-14 "
//       >
//         <DialogHeader className="text-center">
//           <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-brand-14 sm:mb-8 sm:h-16 sm:w-16">
//             <Check className="h-8 w-8 text-neutral-100 sm:h-10 sm:w-10" />
//           </div>

//           <DialogTitle className="text-center text-xl font-bold text-neutral-100 sm:text-2xl">
//             Organisation Created Successfully
//           </DialogTitle>

//           <DialogDescription className="mx-auto mt-4 max-w-xl text-center text-sm leading-relaxed text-neutral-100/80 sm:text-base">
//             The organisation has been set up successfully. You can add
//             experiences or create more campaigns now, or do it later from the
//             organisation profile.
//           </DialogDescription>
//         </DialogHeader>

//         <DialogFooter className="mt-8 flex w-full flex-col gap-3 sm:flex-col md:flex-row md:justify-center">
//           <Button
//             type="button"
//             onClick={onAddExperience}
//             className="h-11 w-full bg-gradient-to-r from-brand-12 to-brand-13 px-5
//               text-sm font-bold text-neutral-100 hover:opacity-90 md:w-auto"
//           >
//             Add Experience to this campaign
//           </Button>

//           {/* <Button
//             type="button"
//             onClick={onAddCampaign}
//             className="h-11 w-full bg-gradient-to-r from-brand-12 to-brand-13 px-5
//               text-sm font-bold text-neutral-100 hover:opacity-90 md:w-auto"
//           >
//             Add Another Campaign
//           </Button> */}

//           <Button
//             type="button"
//             variant="outline"
//             onClick={onClose}
//             className=" h-11 w-full border-[#607A9B] bg-[#223957] px-7
//               text-sm font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100  md:w-auto"
//           >
//             Close
//           </Button>
//         </DialogFooter>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default SuccessModal;
